/**
 * New offers worth adding, until dismissed: the Offers page's "What changed"
 * and the Offers half of Refresh's. Derived server-side from Worth adding, so
 * an offer added or put away there leaves this list too
 * (`GET /api/offers/capture/changes`).
 */
import { authedFetch } from "./api";
import { orThrow } from "./http";

export interface OfferChange {
  key: string;
  kind: "new_offer";
  issuer: string;
  merchant: string;
  terms: string | null;
  /** The cards it is open on, not yet added. */
  cards: string[];
  /** The issuer's other cards it is already added on. Absent from an older server. */
  added_on?: string[];
  /** Pacific day it was first listed, YYYY-MM-DD. */
  on: string;
  /** The capture run that first listed it. */
  run_id: string;
}

export async function fetchOfferChanges(): Promise<OfferChange[]> {
  const res = await authedFetch("/api/offers/capture/changes");
  const body = (await orThrow(res, "Could not load new offers")) as { changes: OfferChange[] };
  return body.changes;
}

async function post(path: string, keys: string[], failure: string): Promise<void> {
  const res = await authedFetch(path, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ keys }),
  });
  await orThrow(res, failure);
}

export function dismissOfferChanges(keys: string[]): Promise<void> {
  return post("/api/offers/capture/changes/dismiss", keys, "Could not dismiss it");
}

export function undismissOfferChanges(keys: string[]): Promise<void> {
  return post("/api/offers/capture/changes/undismiss", keys, "Could not undo that");
}
